import React, { useEffect, useState, useRef } from 'react';
import DocumentMeta from 'react-document-meta';
import { Spin } from 'antd';
import './style.scss';
import {
  CommonStatusStep,
  IAPIServiceConfigItem,
} from '../../../../model/api-modules';
import { getIframeRectStyle } from '../../lib';

interface IProps {
  readonly selectedServiceConfig?: IAPIServiceConfigItem;
  readonly url: string;
  readonly name?: string;
}

export const IframeComponent = React.memo(
  ({ url, selectedServiceConfig, name }: IProps) => {
    const [loadedStep, setLoadedStep] = useState<CommonStatusStep>(
      CommonStatusStep.Pending
    );
    const [iframeInnerStyle, setIframeInnerStyle] =
      useState<React.CSSProperties>({});
    const previousUrlRef = useRef<string>();
    const iframeRef = useRef<HTMLIFrameElement | null>(null);
    // 初始化 + 监听 URL 变化，手动修改 iframe.src（不销毁 DOM）
    useEffect(() => {
      if (iframeRef.current && url && url !== previousUrlRef.current) {
        // 使用平滑过渡方式修改 URL
        iframeRef.current.src = 'about:blank';
        setTimeout(() => {
          if (iframeRef.current) {
            iframeRef.current.src = url;
          }
        }, 50);

        previousUrlRef.current = url;
      }
    }, [url]);

    const bindResizeEvent = () => {
      window.addEventListener('resize', getIframeRectStyleFn, false);
      return () => {
        window.removeEventListener('resize', getIframeRectStyleFn, false);
      };
    };

    useEffect(() => {
      bindResizeEvent();
    }, []);

    const getIframeRectStyleFn = () => {
      setIframeInnerStyle(getIframeRectStyle() || {});
    };

    const onIframeLoaded = () => {
      getIframeRectStyleFn();
      setLoadedStep(CommonStatusStep.Resolve);
    };

    const onIframeError = () => {
      setLoadedStep(CommonStatusStep.Reject);
    };

    const renderIframe = () => {
      const style: React.CSSProperties = {
        width: ' 100%',
        height: '100%',
        border: '0',
        verticalAlign: 'top',
        ...iframeInnerStyle,
      };
      return (
        <div className="iframe-inner">
          <iframe
            ref={iframeRef}
            src={url} // 初始 URL，仅第一次加载会用，后续通过 ref 修改
            style={style}
            onLoad={onIframeLoaded}
            onError={onIframeError}
          ></iframe>
        </div>
      );
    };

    const renderContent = () => {
      // 加载失败
      if (loadedStep === CommonStatusStep.Reject) {
        return null;
      }

      const loading = loadedStep === CommonStatusStep.Pending;
      return (
        <div className="iframe-wrapper show">
          <Spin spinning={loading}>{renderIframe()}</Spin>
        </div>
      );
    };

    return (
      <>
        <DocumentMeta title={selectedServiceConfig?.Name || name || ''} />
        {renderContent()}
      </>
    );
  }
);
